// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
  display: flex;
  z-index: 100;
  align-items: center;
  background: var(--primary-bg-color);
}
.container.full-height {
  min-height: 100vh;
}
.container .content {
  position: relative;
  color: var(--primary-text-color);
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/pages/Errors/ErrorPage.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;AACJ;AACI;EACI,iBAAA;AACR;AAEI;EACI,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAAR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
